import React from "react";
import { Row, Col, Form } from "react-bootstrap";
export default function Step2() {
  const { biz_channel } = this.state;
  return (
    <div>
      <h4 className="text-muted font-weight-light">
        Step 2: Your business channel
      </h4>

      <Form className="pt-3">
        <Form.Group>
          <div className="form-check">
            <label className="form-check-label">
              <input
                type="radio"
                className="form-check-input"
                name="biz_channel"
                value="facebook"
                onChange={this.handleChange}
              />
              <i className="input-helper"></i>
              Facebook
            </label>
          </div>

          <div className="form-check">
            <label className="form-check-label">
              <input
                type="radio"
                className="form-check-input"
                name="biz_channel"
                value="yelp"
                onChange={this.handleChange}
              />
              <i className="input-helper"></i>
              Yelp
            </label>
          </div>

          <div className="form-check">
            <label className="form-check-label">
              <input
                type="radio"
                className="form-check-input"
                name="biz_channel"
                value="whatsapp"
                onChange={this.handleChange}
              />
              <i className="input-helper"></i>
              Whatsapp
            </label>
          </div>


        </Form.Group>
      </Form>
    </div>
  );
}
